import { Navigate, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Card, Space, Typography } from "antd";

import { getClaimById } from "../api/claimAPI";
import { ClaimForm } from "../components/ClaimForm";

const { Title } = Typography;

const UpdateClaim = () => {
  const { id } = useParams();
  const claimId = id;

  const { data: claimData, isLoading } = useQuery({
    queryKey: ["claim", claimId],
    queryFn: () => getClaimById(claimId),
    enabled: !!claimId,
  });

  if (!claimId) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Update Claim
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          Claim Information
        </Title>

        {!isLoading && (
          <ClaimForm
            initialData={{
              ...claimData,
              claimType: claimData.claimType,
              startDate: claimData.startDate,
              endDate: claimData.endDate,
              claimAmount: claimData.claimAmount,
              claimDetails: claimData.claimDetails,
              totalDays: claimData.totalDays,
              fileUrl: claimData.fileUrl,
            }}
            mode="update"
            claimId={claimId}
          />
        )}
      </Card>
    </Space>
  );
};

export default UpdateClaim;
